export const INPUT_PHONE_NUMBER_MASK = [
  '+',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const INPUT_DATE_MASK = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const CREDIT_CARD_EXPIRATION_DATE_MASK = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
];

export const CREDIT_CARD_CVC_MASK = [/\d/, /\d/, /\d/, /\d/];
